/**
 * This method compute a unique id for a given ConsultationType.
 * This ID will never be stored in a JE, it's just for the component to manage a dropdown.
 *
 * But it is still important. Because if we load from a sourceJe we don't search for
 * corresponding value in our allowed consultation types but we just compute an ID
 * from the procedure and the provider stored in the JE.
 * So the ID's must be consistent for a same session.
 *
 * This represents a type of consultation.
 * It regroups a procedure and a provider.
 */
export interface ConsultationType {
  procedure: {
    sourceLabel: string;
    sourceConcept?: string;
    sourceValue: string;
  };
  provider: Record<string, unknown>;
}

export default function (
  consultationType: ConsultationType
): string | undefined {
  const providerKey = consultationType.provider.specialtySourceValue;
  const procedureKey = consultationType.procedure.sourceValue;
  if (providerKey && procedureKey) {
    return `${providerKey}-${procedureKey}`;
  }

  return;
}
